// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '../libs/request'


/**
 * @description 单页信息
 */
export function InfoApi(data) {
    return request({
        url: 'pc/get_info',
        method: 'post',
		data:data
    })
}



// WEBPACK FOOTER //
// ./src/api/info.js